
export const Priority = Object.freeze({
  NORMAL: 0,
  ELEVATED: 8,
  HIGH: 16,
  HIGHEST: 32,
});

export const priorities = Object.freeze(Object.values(Priority));
